<template>
    <div class="HomePage">
        <HeadComponents v-if='$route.meta.headHide != false'/>
        <router-view></router-view>
    </div>
</template>

<script>
import { useRouter } from 'vue-router'
import { onMounted } from 'vue'
import HeadComponents from 'components/HeadComponents.vue'
import { xzLocal } from "@/until/common";

export default {
    name: 'HomePage',
    components: {
        HeadComponents
    },
    setup() {
        // const router = useRouter();

        // onMounted(() => {
        //     const isLoggedIn = xzLocal.get("userToken");

        //     if (!isLoggedIn) {
        //         // 如果未登录，跳转到登录页面
        //         router.push('/login');
        //     }else {
        //         router.push('/transaction');
        //     }
        // });

        return {}
    }
}
</script>

<style lang="less" scoped>
.HomePage {
    background-color: @bg-color;
}
</style>
